import React, { Fragment, useEffect } from "react";
import { clearLessonDetail, fetchDeleteLesson } from "../actions/lesson";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchLessonList } from "../actions/lesson";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const LessonList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "lessons";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { lessonList } = useSelector((state) => state.lessonReducer);

  useEffect(() => {
    dispatch(fetchLessonList());
    dispatch(clearLessonDetail());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/lesson-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteLesson(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("lessonList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: t("lessonList.educationName"),
      field: "educationName",
      filter: "agTextColumnFilter",
      width: 280,
    },
    {
      headerName: t("educationList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      minWidth: 150,
    },
    {
      headerName: t("lessonList.position"),
      field: "position",
      filter: "agTextColumnFilter",
      width: 120,
    },
    {
      headerName: t("lessonList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("lessonList.inactive");
          case "ACTIVE":
            return t("lessonList.active");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("lessonList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("lessonList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={lessonList}
        columnDefs={columnDefs}
        buttonLink={`/lesson-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"lesson-list"}
      />
    </Fragment>
  );
};

export default LessonList;
